/*
 * @Description: 价目管理 新增、编辑弹出层
 * @Author: ma.cq
 * @Date: 2018-10-18 09:33:29
 * @LastEditors: ma.cq
 * @LastEditTime: 2018-11-01 14:16:44
 */
<template>
  <el-dialog title="新增资金同步对账" :visible.sync="visible" @close="handleClose" width="600px">
    <el-form class="form" :model="form" :rules="rules" ref="form" v-if="visible">
      <el-form-item label="对账周期" prop="offersFlag" label-width="100px">
        <el-radio-group v-model="form.offersFlag">
          <div class="radioBox">
            <el-radio :label="3">不对账</el-radio>
          </div>
          <div class="radioBox">
            <el-radio :label="1">每日对账<br/><span class="infoText">每日凌晨自动拉取前一日资金同步流水进行对账</span></el-radio>
          </div>
          <div class="radioBox">
            <el-radio :label="2">每周对账<br/><span class="infoText">每周一凌晨自动拉取前一周的资金流水进行对账</span></el-radio>
          </div>
          <!-- <div class="radioBox">
            <el-radio :label="3">每月对账<br/><span class="infoText">每月1号凌晨自动拉取上一月的资金流水进行对账</span></el-radio>
          </div> -->
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'addOrEditDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      form: {
        offersFlag: 3
      },
      forms: {
        offersFlag: 3
      },
      rules: {
        lockStartTime: [
          { required: true, message: '请输入时间' }
        ]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$emit('onform', this.form)
      this.$emit('update:show', false)
      this.form = this.forms
    },
    handleClose () {
      this.form = this.forms
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
    }
  }
}
</script>
<style lang="scss" scoped>
.form{
  margin: 0 auto;
  max-width: 500px;
}
.item-inline{
  display: inline-block;
}
.marLef10{
  margin-left: 10px;
}
.tip{
  color: #ccc;
  font-size: 12px;
}
.tag{
  margin: 10px 10px 0 0;
}
.timepicker{
  margin-right: 10px;
  width: 120px;
}
.radioBox {
  margin-top: 10px;
}
.infoText {
  font-size: 12px;
  color: #999;
  margin-left: 24px;
  margin-top: 4px;
}
</style>
